<template>
  <div class="member-layout" @click="stopCountDown">
    <MemberHeader />
    <div :class="[{ 'pt-3': !disabledPadding }]">
      <slot />
    </div>
    <MemberNavbar :activeLink="activeLink" />
    <b-modal
      id="showFinalLogoutAlert"
      no-close-on-backdrop
      hide-header
      hide-footer
    >
      <template>
        <div>
          <h4>系統即將自動登出</h4>
          <p>
            因網站閒置時間已超過{{ countDownMin }}分，系統將於
            <span class="text-danger">{{ finalCallSecShow }}</span>
            秒後自動登出
          </p>
          <div>
            <button @click="logout" class="btn btn-danger mr-2">
              直接登出
            </button>
            <button @click="stopFinalCall" class="btn btn-secondary">
              繼續使用
            </button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import MemberHeader from "./MemberHeader";
import MemberNavbar from "./MemberNavbar";
import { mapActions } from "vuex";
import firebase from "../../api/firebase";
import db from "../../api/db";

export default {
  name: "MemberLayout",
  props: ["activeLink", "disabledPadding"],
  components: {
    MemberHeader,
    MemberNavbar,
  },
  data() {
    return {
      countDownMin: 0,
      finalCallSec: 0,
      finalCallSecShow: 0,
      isCountDown: false,
      countDownTimeout: null,
      finalCallInterval: null,
    };
  },
  methods: {
    ...mapActions(["singOutAuth"]),
    startCountDown() {
      const vm = this;
      const { countDownMin } = vm;
      const countDownTimestamp = countDownMin * 60 * 1000;
      vm.isCountDown = true;
      vm.countDownTimeout = setTimeout(() => {
        vm.showFinalLogoutAlert();
      }, countDownTimestamp);
    },
    stopCountDown() {
      const vm = this;
      clearTimeout(vm.countDownTimeout);
      // Restart count down
      // vm.startCountDown();
    },
    showFinalLogoutAlert() {
      const vm = this;
      const { finalCallSec } = vm;
      vm.finalCallSecShow = finalCallSec;
      vm.$bvModal.show("showFinalLogoutAlert");
      vm.startFinalCall();
    },
    startFinalCall() {
      const vm = this;
      const { finalCallSec } = vm;
      let c = 0;
      vm.finalCallInterval = setInterval(() => {
        c += 1;
        if (c > finalCallSec) {
          clearInterval(vm.finalCallInterval);
          vm.finalCallInterval = null;
          vm.logout();
        } else {
          vm.finalCallSecShow -= 1;
        }
      }, 1000);
    },
    stopFinalCall() {
      const vm = this;
      clearInterval(vm.finalCallInterval);
      vm.finalCallInterval = null;
      vm.$bvModal.hide("showFinalLogoutAlert");
      // Restart count down
      vm.startCountDown();
    },
    logout() {
      const vm = this;
      firebase
        .auth()
        .signOut()
        .then(() => {
          vm.singOutAuth();
          window.location = "/login";
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    const vm = this;
    db.doc("frontendEnv/autoLogoutConfig")
      .get()
      .then((doc) => {
        const autoLogoutConfig = doc.data();
        const { countDownMin, finalCallSec } = autoLogoutConfig;
        vm.countDownMin = countDownMin;
        vm.finalCallSec = finalCallSec;
        if (!vm.countDownTimeout) {
          vm.startCountDown();
        }
      })
      .catch((err) => console.log(err));
  },
  destroyed() {
    const vm = this;
    vm.stopCountDown();
    vm.stopFinalCall();
  },
};
</script>
<style lang="scss" scoped>
</style>